<template>
  <div class="fd-px-4 fd-py-6">
    <div class="fd-w-full fd-flex fd-items-center fd-justify-start fd-mb-4">
      <span class="fd-text-lg fd-font-semibold fd-text-theme-2">{{ $t('onlineSetting.onlineSetting') }}</span>
    </div>
    <span class="fd-block fd-mt-8 fd-mb-3 fd-text-lg fd-font-bold fd-text-theme-6">{{ $t('onlineSetting.branding') }}</span>
    <div class="fd-w-full fd-px-3 fd-flex fd-items-end fd-mt-4 fd-border-b fd-pb-8">
      <div class="fd-w-1/3">
        <div
          @click="selectFile"
          class="fd-relative fd-cursor-pointer fd-w-24 fd-h-24 fd-rounded-lg fd-overflow-hidden"
          style="border: 1px solid #E8E8E8;"
        >
          <img
            v-if="getNewImageUrl || (onlineSetting && onlineSetting.thumbnail)"
            class="fd-w-full fd-h-full" :src="getThumbnail"
            alt="avatar"
          >
          <span v-else class="fd-block fd-w-full fd-h-full fd-bg-gray-400"></span>
          <span v-if="!(onlineSetting && onlineSetting.thumbnail)" class="fd-block fd-w-full fd-h-full fd-absolute fd-left-0 fd-top-0 fd-opacity-0 hover:fd-opacity-70 fd-bg-white">
            <SvgLoader name="exportIcon2" class="fd-absolute" style="left: 50%; top: 50%; transform: translate(-50%, -50%)" />
          </span>
        </div>
      </div>

      <div class="fd-w-2/3 fd-flex fd-items-start fd-justify-start">
        <input type="file" ref="file" @change="changeFile" style="display: none">
        <b-button @click="selectFile" variant="primary" class="fd-mr-4 btn-custom">{{ $t('global.upload') }}</b-button>
        <b-button @click="resetFile" variant="outline-primary" class="btn-custom">{{ $t('global.reset') }}</b-button>
      </div>
    </div>
    <span class="fd-block fd-mt-8 fd-mb-3 fd-text-lg fd-font-bold fd-text-theme-6">{{ $t('onlineSetting.socialNetwork') }}</span>
    <div class="fd-w-full fd-px-3 fd-py-5 fd-flex fd-items-center fd-justify-between">
      <label for="instagram" class="fd-block fd-w-1/3 fd-text-sm fd-text-theme-6 fd-font-bold fd-flex fd-items-center">
        <span>{{ $t('onlineSetting.instagram') }}</span>
      </label>
      <div class="fd-w-2/3">
        <b-form-input
          id="instagram"
          v-model="form.instagram"
          :placeholder="$t('onlineSetting.inputSocialNetwork')"
        />
      </div>
    </div>
    <div class="fd-w-full fd-px-3 fd-py-5 fd-flex fd-items-center fd-justify-between">
      <label for="facebook" class="fd-block fd-w-1/3 fd-text-sm fd-text-theme-6 fd-font-bold fd-flex fd-items-center">
        <span>{{ $t('onlineSetting.facebook') }}</span>
      </label>
      <div class="fd-w-2/3">
        <b-form-input
          id="facebook"
          v-model="form.facebook"
          :placeholder="$t('onlineSetting.inputSocialNetwork')"
        />
      </div>
    </div>
    <div class="fd-w-full fd-px-3 fd-py-5 fd-flex fd-items-center fd-justify-between">
      <label for="linkedin" class="fd-block fd-w-1/3 fd-text-sm fd-text-theme-6 fd-font-bold fd-flex fd-items-center">
        <span>{{ $t('onlineSetting.linkedin') }}</span>
      </label>
      <div class="fd-w-2/3">
        <b-form-input
          id="linkedin"
          v-model="form.linkedin"
          :placeholder="$t('onlineSetting.inputSocialNetwork')"
        />
      </div>
    </div>
    <div>
      <span class="fd-block fd-mt-8 fd-mb-3 fd-text-lg fd-font-bold fd-text-theme-6">{{ $t('onlineSetting.customDomain') }}</span>
      <div class="fd-w-full fd-px-3 fd-py-5 fd-flex fd-items-center fd-justify-between fd-pb-8">
        <label for="domain" class="fd-block fd-w-1/3 fd-text-sm fd-text-theme-6 fd-font-bold fd-flex fd-items-center">
          <span>{{ $t('onlineSetting.domain') }}</span>
        </label>
        <div class="fd-w-2/3">
          <b-form-input
            id="domain"
            v-model="custom_domain"
            :placeholder="$t('onlineSetting.domain')"
          />
        </div>
      </div>
    </div>
    <div class="fd-w-full fd-flex fd-items-start fd-justify-end fd-mt-8 fd-pr-3">
      <b-button
        @click="save"
        variant="primary"
        style="padding-left: 35px !important; padding-right: 35px !important;"
      >
        {{ $t('global.save') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BFormInput, BButton } from 'bootstrap-vue'
import {mapGetters} from "vuex";

export default {
  name: "Branding",
  components: {BFormInput, BButton},
  data() {
    return {
      form: {
        instagram: '',
        facebook: '',
        linkedin: ''
      },
      custom_domain: '',
      image: null,
      newImageUrl: null,
    }
  },
  created() {
    this.$store.dispatch('project/getOnlineSetting', this.$route.params.id).then(() => {
      let onlineSetting = this.$store.getters["project/onlineSetting"]
      if (!onlineSetting) return {}
      onlineSetting.social_network.forEach(item => {
        this.form[item.title] = item.url
      })
      this.custom_domain = onlineSetting.custom_domain
    })
  },
  computed: {
    onlineSetting() {
      return  this.$store.getters["project/onlineSetting"]
    },
    getNewImageUrl() {
      return this.newImageUrl
    },
    getThumbnail() {
      if (this.newImageUrl) {
        return this.getNewImageUrl
      }
      if (this.onlineSetting && this.onlineSetting.thumbnail) {
        return this.onlineSetting.thumbnail
      }
      return require('@/assets/images/pages/project/default-image.png')
    }
  },
  methods: {
    save() {
      let social_network = []
      let formData = new FormData()

      if (this.image) {
        formData.append('thumbnail', this.image)
      }

      Object.keys(this.form).forEach(key => {
        social_network.push({
          title: key,
          url: this.form[key]
        })
      })
      // let data = {
      //   social_network,
      //   custom_domain: this.custom_domain
      // }
      // if (this.image) {
      //   data.thumbnail = formData.get('thumbnail')
      // }
      formData.append('social_network', JSON.stringify(social_network))
      formData.append('custom_domain', this.custom_domain)

      this.$store.dispatch('project/updateOnlineSetting', {
        id: this.$route.params.id,
        data: formData
      })
    },
    selectFile() {
      this.$refs.file.click()
    },
    changeFile() {
      this.image = this.$refs.file.files[0]
      this.newImageUrl = URL.createObjectURL(this.image)
      this.$refs.file.value = ''
    },
    resetFile() {
      this.image = null
      this.newImageUrl = null
    },
    upload() {
      if (!this.newImageUrl) {
        this.selectFile()
        return
      }
      let formData = new FormData()
      formData.append('thumbnail', this.image)
      this.$store.dispatch('project/updateOnlineSetting', {
        id: this.$route.params.id,
        data: formData
      })
    }
  }
}
</script>

<style scoped>

</style>